/* 布局 */
//前台
import Layout from "@views/layout";

const noticeclassRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "noticeclass/list",
        name: "NOTICECLASS",
        meta: {
            title: "文章公告分类管理",
            keepAlive:true
        },
        component: () => import("@views/business/noticeclass/index.vue"),
    },
        ],
};

export default noticeclassRouter;
